import React, { useCallback, useEffect, useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import { fetchAutenticat } from "../../utils/auth";
import AjudaMestres from "./AjudaMestres";
import { BotoAjuda } from "./AjudaModal";

function Detallstipuspausa({
  mode,
  tipus,
  tipusLlista,
  onNavigate,
  onSave,
  onCancel,
  onCanviarMode,
  onDeleted,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";
  TeclaEscEnter(onCancel, null);
  const { empresaSeleccionada, rolUsuari } = useUserContext();

  const [codi, setCodi] = useState("");
  const [nom, setNom] = useState("");
  const [computaTempsTreball, setComputaTempsTreball] = useState(false);
  const [visible, setVisible] = useState(true);
  const [duradaPrevistaMinuts, setDuradaPrevistaMinuts] = useState("");
  const [ordre, setOrdre] = useState("");
  const [actiu, setActiu] = useState(true);
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const resetForm = useCallback(() => {
    setCodi("");
    setNom("");
    setComputaTempsTreball(false);
    setVisible(true);
    setDuradaPrevistaMinuts("");
    setOrdre("");
    setActiu(true);
  }, []);

  useEffect(() => {
    if (tipus && mode !== "nou") {
      setCodi(tipus.Codi || "");
      setNom(tipus.Nom || "");
      setComputaTempsTreball(Number(tipus.ComputaTempsTreball) === 1);
      setVisible(Number(tipus.Visible) === 1);
      setDuradaPrevistaMinuts(tipus.DuradaPrevistaMinuts ?? "");
      setOrdre(tipus.Ordre ?? "");
      setActiu(Number(tipus.Actiu) === 1);
    } else if (mode === "nou") {
      resetForm();
    }
    setMenuAccions(false);
  }, [tipus, mode, resetForm]);

  const llista = Array.isArray(tipusLlista) ? tipusLlista : [];
  const indexActual = tipus
    ? llista.findIndex((t) => Number(t.idTipusPausaEmpleats) === Number(tipus.idTipusPausaEmpleats))
    : -1;
  const potNavegar = ["consultar", "modificar"].includes(mode) && llista.length > 1 && indexActual >= 0;

  const anarAnterior = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === 0 ? llista.length - 1 : indexActual - 1;
    onNavigate?.(llista[nouIndex]);
  };

  const anarSeguent = () => {
    if (!potNavegar) return;
    const nouIndex = indexActual === llista.length - 1 ? 0 : indexActual + 1;
    onNavigate?.(llista[nouIndex]);
  };

  const validar = () => {
    const errors = [];
    if (!codi.trim()) errors.push("El camp Codi és obligatori.");
    if (!nom.trim()) errors.push("El camp Nom és obligatori.");
    if (duradaPrevistaMinuts !== "" && Number(duradaPrevistaMinuts) < 0) {
      errors.push("La Durada prevista no pot ser negativa.");
    }
    return errors;
  };

  const handleSubmit = async () => {
    if (mode !== "esborrar") {
      const errors = validar();
      if (errors.length > 0) {
        alert(`Errors trobats:\n${errors.join("\n")}`);
        return;
      }
    }

    const payload = {
      idEmpresa: empresaSeleccionada?.IdEmpresa || null,
      Codi: codi.trim(),
      Nom: nom.trim(),
      ComputaTempsTreball: computaTempsTreball,
      Visible: visible,
      DuradaPrevistaMinuts: duradaPrevistaMinuts === "" ? null : Number(duradaPrevistaMinuts),
      Ordre: ordre === "" ? null : Number(ordre),
      Actiu: actiu,
    };

    try {
      if (mode === "nou") {
        const response = await fetchAutenticat(`${API_URL}/NouTipusPausa.php`, {
          method: "POST",
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({ ...payload, idTipusPausaEmpleats: data.idTipusPausaEmpleats });
        } else {
          alert(`Error en crear el Tipus de pausa: ${data.message}`);
        }
      } else if (mode === "modificar") {
        payload.idTipusPausaEmpleats = tipus.idTipusPausaEmpleats;
        const response = await fetchAutenticat(`${API_URL}/ModificarTipusPausa.php`, {
          method: "POST",
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (data.success) {
          onSave?.({ ...tipus, ...payload });
        } else {
          alert(`Error en modificar el Tipus de pausa: ${data.message}`);
        }
      } else if (mode === "esborrar") {
        const response = await fetchAutenticat(`${API_URL}/EsborrarTipusPausa.php`, {
          method: "POST",
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa || null,
            idTipusPausaEmpleats: tipus.idTipusPausaEmpleats,
          }),
        });
        const data = await response.json();
        if (data.success) {
          onDeleted?.();
        } else {
          alert(`Error en esborrar el Tipus de pausa: ${data.message}`);
        }
      }
    } catch (error) {
      console.error("Error en l'operació del Tipus de pausa:", error);
      alert("S'ha produït un error en el procés.");
    }
  };

  const toggle = (checked, onChange) => (
    <span className="dv2-toggleRow">
      <span className="dv2-toggle">
        <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
        <span className="dv2-toggle-track" />
      </span>
    </span>
  );

  const camp = (label, required, content, mida = "mig") => {
    const extra =
      mida === "ample" ? "dv2-field--ample" : mida === "llarg" ? "dv2-field--llarg" : mida === "curt" ? "dv2-field--curt" : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </label>
    );
  };

  const titol =
    mode === "nou"
      ? "Nou tipus de pausa"
      : mode === "esborrar"
      ? "Esborrar tipus de pausa"
      : mode === "modificar"
      ? "Modificar tipus de pausa"
      : "Tipus de pausa · Fitxa";

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaMestres pestanya="tipuspausa" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "☕"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titol}</h1>
            <p className="dv2-pageHeader-subtitle">
              {mode === "nou" ? "Omple el catàleg de pausa." : mode === "esborrar" ? "Aquesta acció no es pot desfer si el tipus ja s'ha fet servir." : nom || "Dades del tipus"}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funcionen els Tipus de pausa" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && tincPermis(rolUsuari, "MODIFICAR") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && tincPermis(rolUsuari, "ESBORRAR") && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  <button
                    type="button"
                    className="dv2-menu-item is-danger"
                    onClick={() => {
                      setMenuAccions(false);
                      onCanviarMode?.("esborrar");
                    }}
                  >
                    Esborrar
                  </button>
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar tipus
            </button>
          )}
        </div>
      </div>

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si el tipus ja s'ha fet servir, el servidor pot no deixar-lo esborrar.
        </div>
      )}

      <div className="dv2-entity-body">
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">1</span>
            <h2 className="dv2-card-title">Identificació</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp("Codi", true, isReadOnly ? <span className="dv2-value">{codi || "—"}</span> : <input type="text" className="dv2-input" value={codi} maxLength={45} autoFocus onChange={(e) => setCodi(e.target.value)} />, "curt")}
            {camp("Nom", true, isReadOnly ? <span className="dv2-value">{nom || "—"}</span> : <input type="text" className="dv2-input" value={nom} maxLength={100} onChange={(e) => setNom(e.target.value)} />, "llarg")}
            {camp("Ordre", false, isReadOnly ? <span className="dv2-value">{ordre !== "" ? ordre : "—"}</span> : <input type="number" className="dv2-input" value={ordre} onChange={(e) => setOrdre(e.target.value)} />, "curt")}
            {camp(
              "Durada prevista (minuts)",
              false,
              isReadOnly ? (
                <span className="dv2-value">{duradaPrevistaMinuts !== "" ? `${duradaPrevistaMinuts} minuts` : "Sense definir"}</span>
              ) : (
                <input type="number" min="0" className="dv2-input" value={duradaPrevistaMinuts} onChange={(e) => setDuradaPrevistaMinuts(e.target.value)} />
              ),
              "curt"
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">2</span>
            <h2 className="dv2-card-title">Comportament</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp("Computa com a temps de treball", false, isReadOnly ? <span className="dv2-value">{computaTempsTreball ? "Sí" : "No"}</span> : toggle(computaTempsTreball, setComputaTempsTreball), "llarg")}
            {camp("Visible al mòbil", false, isReadOnly ? <span className="dv2-value">{visible ? "Sí" : "No"}</span> : toggle(visible, setVisible), "curt")}
            {camp("Actiu", false, isReadOnly ? <span className="dv2-value">{actiu ? "Sí" : "No"}</span> : toggle(actiu, setActiu), "curt")}
          </div>
        </section>
      </div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarAnterior} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {indexActual + 1} / {llista.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anarSeguent} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar tipus
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar tipus" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallstipuspausa;
